import { axiosInstance } from "@/helper/axios-instance";
import type { StockPriceRegister, DataAwareResponse } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useStockPriceRegisterDelete() {
  return useMutationWithValidation({
    mutationFn: async (id: string | null) => {
      const response = await axiosInstance({
        method: "DELETE",
        url:  `StockPriceRegister/Delete?id=${id}`,
      });

      return response.data as DataAwareResponse<StockPriceRegister>;
    },
    retry: 2,
    customMessage: {
      success: "Stock price register deleted successfully",
    },
  });
}
